(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biotine-landing"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════
   BIOTINE SELVERINE — Landing section scripts
   Ported 1:1 from the main SELVERINE landing section's engine:
   same SLVPixel wrapper, same reveal-on-scroll observer, same COD
   form validation/submit flow, same WhatsApp widget. Trimmed to
   only what this page actually renders (single fixed-price product,
   no nav/bundle-selector/texture-bars).
═══════════════════════════════════════════════ */

const SLVPixel = (function () {
  function cookie(name) {
    const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function param(name) {
    return new URLSearchParams(location.search).get(name) || '';
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  const fbclid = param('fbclid');
  if (fbclid && !cookie('_fbc')) {
    try { localStorage.setItem('slv_fbclid', fbclid); } catch (e) {}
  }
  function getFbclid() {
    return fbclid || (function () { try { return localStorage.getItem('slv_fbclid') || ''; } catch (e) { return ''; } })();
  }
  function getFbc() {
    const c = cookie('_fbc');
    if (c) return c;
    const id = getFbclid();
    return id ? `fb.1.${Date.now()}.${id}` : '';
  }
  function ready() { return typeof window.fbq === 'function' || !!window.ttq; }

  return {
    available: ready,
    data() {
      return { fbp: cookie('_fbp'), fbc: getFbc(), fbclid: getFbclid() };
    },
    newEventId: uuid,
    track(event, custom, eventId) {
      // Fans out to Meta + TikTok with a shared event id (see snippets/slv-track.liquid).
      try {
        if (window.SLVTrack) return window.SLVTrack.track(event, custom || {}, eventId);
        if (typeof window.fbq === 'function') {
          window.fbq('track', event, custom || {}, eventId ? { eventID: eventId } : undefined);
        }
      } catch (e) { /* never break UX for analytics */ }
    },
    viewContent(productName, currency) {
      this.track('ViewContent', {
        content_name: productName || 'بيوتين SELVERINE',
        content_ids: ['biotine'],
        content_type: 'product',
        currency: currency || 'MAD',
      });
    },
    initiateCheckout(value, currency) {
      this.track('InitiateCheckout', {
        content_ids: ['biotine'],
        content_type: 'product',
        currency: currency || 'MAD',
        value: Number(value) || 0,
      });
    },
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  const CURRENCY = 'MAD';

  SLVPixel.viewContent('بيوتين SELVERINE', CURRENCY);

  // ── SCROLL ANIMATIONS — identical observer to the main page ──
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = parseInt(el.dataset.delay) || 0;
        setTimeout(() => el.classList.add('in-view'), delay);
        revealObserver.unobserve(el);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.fade-up, .fade-in')
    .forEach((el) => revealObserver.observe(el));


  // ── FAQ ACCORDION — identical to the main page ──
  const firstFaq = document.querySelector('.faq-item--open');
  if (firstFaq) {
    const firstAnswer = firstFaq.querySelector('.faq-item__answer');
    if (firstAnswer) firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
  }

  document.querySelectorAll('.faq-item').forEach((item) => {
    const btn = item.querySelector('.faq-item__question');
    const answer = item.querySelector('.faq-item__answer');

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.faq-item').forEach((i) => {
        i.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        i.querySelector('.faq-item__answer').style.maxHeight = '0';
      });

      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });


  // ── PRODUCT CONFIG — single fixed price, no bundle selector ──
  let CFG = { workerUrl: '', variantId: null, price: 9900, priceFormatted: '99 dh' };
  try {
    const raw = JSON.parse(document.getElementById('biotine-cod-config').textContent);
    CFG = Object.assign(CFG, raw);
  } catch (e) {}

  const fmtDh = (cents) => Math.round(cents / 100).toLocaleString('fr-FR') + ' dh';


  // ── INLINE ORDER FORM ────────────────────────────────────────
  // Every CTA scrolls to the form and focuses the first field.
  // InitiateCheckout fires once, the first time the form is reached.
  const orderInline = document.querySelector('[data-order-inline]');
  let checkoutPixelSent = false;

  function goToOrderForm() {
    if (!orderInline) return;
    orderInline.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (!checkoutPixelSent) {
      SLVPixel.initiateCheckout(CFG.price, CURRENCY);
      checkoutPixelSent = true;
    }
    const firstInput = orderInline.querySelector('input[name="name"]');
    if (firstInput) {
      // Wait for the smooth scroll to settle before focusing, otherwise
      // mobile browsers jump the viewport and fight the scroll animation.
      setTimeout(() => firstInput.focus({ preventScroll: true }), 550);
    }
  }

  document.querySelectorAll('[data-order]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      goToOrderForm();
    });
  });

  // ── COD ORDER — same Worker contract as the main page: collect
  //    name + phone, POST to the Cloudflare Worker, which creates a
  //    real Shopify order via the Admin API. No Shopify cart/checkout.
  const omForm = document.querySelector('[data-om-form]');
  const omFormError = document.querySelector('[data-om-form-error]');
  const omSubmitBtn = document.querySelector('[data-om-submit]');

  function readField(name) {
    const el = omForm ? omForm.querySelector(`[name="${name}"]`) : null;
    return { el, value: el ? el.value.trim() : '' };
  }
  function setFieldError(name, message) {
    const { el } = readField(name);
    const errEl = omForm ? omForm.querySelector(`[data-err-for="${name}"]`) : null;
    if (el) el.classList.toggle('is-invalid', Boolean(message));
    if (errEl) errEl.textContent = message || '';
  }
  function validateForm() {
    const name = readField('name').value;
    const phone = readField('phone').value;
    setFieldError('name', name.length >= 2 ? '' : 'Entrez votre nom complet');
    const phoneDigits = phone.replace(/\D/g, '');
    setFieldError('phone', phoneDigits.length >= 8 ? '' : 'Numéro de téléphone invalide');
    const ok = name.length >= 2 && phoneDigits.length >= 8;
    return ok ? { name, phone } : null;
  }

  if (omForm) {
    omForm.querySelectorAll('input').forEach((input) => {
      input.addEventListener('input', () => setFieldError(input.name, ''));
    });
  }

  if (omSubmitBtn) {
    omSubmitBtn.addEventListener('click', async () => {
      if (omFormError) { omFormError.hidden = true; omFormError.textContent = ''; }

      const cust = validateForm();
      if (!cust) {
        const firstInvalid = omForm.querySelector('.is-invalid');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      if (!CFG.workerUrl || !CFG.variantId) {
        if (omFormError) {
          omFormError.hidden = false;
          omFormError.textContent = 'Configuration manquante. Veuillez réessayer plus tard.';
        }
        return;
      }

      const originalText = omSubmitBtn.textContent;
      omSubmitBtn.textContent = 'Traitement…';
      omSubmitBtn.disabled = true;

      SLVPixel.initiateCheckout(CFG.price, CURRENCY);

      try {
        const res = await fetch(CFG.workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: cust.name,
            phone: cust.phone,
            variantId: CFG.variantId,
            quantity: 1,
            price: CFG.price,
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) throw new Error(data.error || 'order failed');

        SLVPixel.track('Purchase', {
          content_ids: ['biotine'],
          content_type: 'product',
          currency: data.currency || CURRENCY,
          value: Number(data.total) || (CFG.price / 100),
        });

        // No branded overlay on this page yet — redirect to the shared
        // thank-you page, same pattern as the pack page's post-purchase flow.
        const params = new URLSearchParams({
          ref: data.order_name || '',
          total: fmtDh(CFG.price),
          name: cust.name.split(' ')[0] || cust.name,
        });
        window.location.href = '/pages/merci?' + params.toString();
      } catch (err) {
        omSubmitBtn.textContent = originalText;
        omSubmitBtn.disabled = false;
        if (omFormError) {
          omFormError.hidden = false;
          omFormError.textContent = 'Une erreur est survenue. Veuillez réessayer.';
        }
      }
    });
  }


  // ── SMOOTH SCROLL (in-page anchors only) — identical to main page ──
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (link.hasAttribute('data-order')) return;
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });


  // ── PARALLAX HERO (desktop only — skip on touch devices) ──
  const heroImg = document.querySelector('.hero__image');
  const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (heroImg && !isTouchDevice) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < window.innerHeight) {
        heroImg.style.transform = `translateY(${y * 0.12}px)`;
      }
    }, { passive: true });
  }


  // ── TESTIMONIAL SLIDER (dots, matches main page structure) ──
  const testiTrack = document.querySelector('[data-testi-track]');
  const testiDots = document.querySelector('[data-testi-dots]');
  if (testiTrack && testiDots) {
    const slides = [...testiTrack.children];

    slides.forEach((slide, i) => {
      const dot = document.createElement('button');
      dot.className = 'testi-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', `Avis ${i + 1}`);
      dot.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      testiDots.appendChild(dot);
    });
    const dotEls = [...testiDots.children];

    // One shared observer watching every slide, rather than one observer
    // per slide — same result, a fraction of the observer instances.
    const dotObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const idx = slides.indexOf(entry.target);
        if (idx === -1) return;
        dotEls.forEach((d) => d.classList.remove('is-active'));
        dotEls[idx].classList.add('is-active');
      });
    }, { root: testiTrack, threshold: 0.6 });

    slides.forEach((slide) => dotObserver.observe(slide));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selverine-landing-fr"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════
   SELVERINE — Landing section scripts (Shopify port)
═══════════════════════════════════════════════ */

const SLVPixel = (function () {
  function cookie(name) {
    const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function param(name) {
    return new URLSearchParams(location.search).get(name) || '';
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  const fbclid = param('fbclid');
  if (fbclid && !cookie('_fbc')) {
    try { localStorage.setItem('slv_fbclid', fbclid); } catch (e) {}
  }
  function getFbclid() {
    return fbclid || (function () { try { return localStorage.getItem('slv_fbclid') || ''; } catch (e) { return ''; } })();
  }
  function getFbc() {
    const c = cookie('_fbc');
    if (c) return c;
    const id = getFbclid();
    return id ? `fb.1.${Date.now()}.${id}` : '';
  }
  function ready() { return typeof window.fbq === 'function' || !!window.ttq; }

  return {
    available: ready,
    data() {
      return { fbp: cookie('_fbp'), fbc: getFbc(), fbclid: getFbclid() };
    },
    newEventId: uuid,
    track(event, custom, eventId) {
      // Fans out to Meta + TikTok with a shared event id.
      try {
        if (window.SLVTrack) return window.SLVTrack.track(event, custom || {}, eventId);
        if (typeof window.fbq === 'function') {
          window.fbq('track', event, custom || {}, eventId ? { eventID: eventId } : undefined);
        }
      } catch (e) { /* never break UX for analytics */ }
    },
    viewContent(productName, currency) {
      this.track('ViewContent', {
        content_name: productName || 'SELVERINE',
        content_ids: ['selverine'],
        content_type: 'product',
        currency: currency || 'MAD',
      });
    },
    initiateCheckout(value, currency) {
      this.track('InitiateCheckout', {
        content_ids: ['selverine'],
        content_type: 'product',
        currency: currency || 'MAD',
        value: Number(value) || 0,
      });
    },
  };
})();

document.addEventListener('DOMContentLoaded', () => {

  const root = document.querySelector('[data-whatsapp-number]')?.closest('[id^="shopify-section-"]') || document;

  const variantDataEl = document.getElementById('selverine-variants-data');
  const SLV_VARIANTS = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  const CURRENCY = 'MAD';

  SLVPixel.viewContent('SELVERINE', CURRENCY);

  // ── SCROLL ANIMATIONS ──────────────────────────────────────
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = parseInt(el.dataset.delay) || 0;
        setTimeout(() => el.classList.add('in-view'), delay);
        revealObserver.unobserve(el);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.fade-up, .fade-in')
    .forEach(el => revealObserver.observe(el));


  // ── STICKY BAR ─────────────────────────────────────────────
  const stickyBar = document.querySelector('[data-sticky-bar]');
  const hero      = document.querySelector('.hero');

  if (hero && stickyBar) {
    new IntersectionObserver((entries) => {
      entries.forEach(e => {
        const visible = !e.isIntersecting;
        stickyBar.classList.toggle('is-visible', visible);
        if (whatsappWidget) whatsappWidget.classList.toggle('is-above-cta', visible);
      });
    }, { threshold: 0 }).observe(hero);
  }

  // ── WHATSAPP FLOATING WIDGET ─────────────────────────────────
  const whatsappNumber = document.querySelector('[data-whatsapp-number]')?.dataset.whatsappNumber || '212780953565';
  const isArabicPage = document.documentElement.lang === 'ar';
  const whatsappMessage = isArabicPage
    ? 'مرحبا 👋، عندي سؤال على SELVERINE'
    : 'Bonjour 👋, j\'ai une question sur SELVERINE';
  const waHref = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  const bubbleHTML = isArabicPage
    ? '👋 عندك سؤال؟ <strong>راسلنا على واتساب</strong>، كنجاوبو بسرعة 💬'
    : '👋 Une question ? <strong>Écrivez-nous sur WhatsApp</strong> — réponse en quelques minutes 💬';
  const closeLabel = isArabicPage ? 'إغلاق' : 'Fermer';
  const waSvg = '<svg viewBox="0 0 32 32" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M16.004 2.667c-7.36 0-13.333 5.973-13.333 13.333 0 2.351.615 4.646 1.783 6.667L2.667 29.333l6.83-1.76a13.27 13.27 0 0 0 6.507 1.694h.006c7.36 0 13.333-5.973 13.333-13.333S23.364 2.667 16.004 2.667zm0 24.4h-.005a11.06 11.06 0 0 1-5.636-1.543l-.404-.24-4.052 1.044 1.08-3.948-.264-.406a11.04 11.04 0 0 1-1.69-5.907c0-6.106 4.968-11.073 11.076-11.073 2.958 0 5.738 1.153 7.83 3.246a10.996 10.996 0 0 1 3.242 7.834c-.003 6.106-4.971 11.073-11.077 11.073zm6.077-8.294c-.333-.167-1.966-.97-2.271-1.081-.305-.111-.527-.167-.749.167-.222.333-.86 1.08-1.055 1.303-.194.222-.388.25-.72.083-.333-.167-1.406-.518-2.678-1.652-.99-.883-1.658-1.974-1.852-2.307-.194-.333-.02-.513.146-.679.15-.149.333-.389.5-.583.167-.194.222-.333.333-.556.111-.222.056-.417-.028-.583-.083-.167-.749-1.807-1.026-2.474-.27-.65-.545-.562-.749-.573l-.638-.011c-.222 0-.583.083-.888.417-.305.333-1.164 1.138-1.164 2.776 0 1.638 1.192 3.221 1.358 3.443.167.222 2.347 3.583 5.687 5.024.795.343 1.415.548 1.898.702.797.253 1.523.217 2.096.132.639-.095 1.966-.804 2.243-1.581.278-.777.278-1.443.194-1.581-.083-.139-.305-.222-.638-.389z"/></svg>';

  const whatsappWidget = document.createElement('div');
  whatsappWidget.className = 'whatsapp-widget';
  whatsappWidget.innerHTML =
    '<a class="whatsapp-bubble" href="' + waHref + '" target="_blank" rel="noopener noreferrer">' +
      '<span class="whatsapp-bubble__text">' + bubbleHTML + '</span>' +
    '</a>' +
    '<button class="whatsapp-bubble__close" type="button" aria-label="' + closeLabel + '">&times;</button>' +
    '<a class="whatsapp-fab" href="' + waHref + '" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">' + waSvg + '</a>';
  document.body.appendChild(whatsappWidget);

  let bubbleClosed = false;
  try { bubbleClosed = sessionStorage.getItem('waBubbleClosed') === '1'; } catch (e) {}
  if (!bubbleClosed) {
    setTimeout(() => whatsappWidget.classList.add('bubble-open'), 2000);
  }
  const whatsappClose = whatsappWidget.querySelector('.whatsapp-bubble__close');
  whatsappClose.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    whatsappWidget.classList.remove('bubble-open');
    try { sessionStorage.setItem('waBubbleClosed', '1'); } catch (err) {}
  });

  // ── STICKY BAR HEIGHT → CSS VAR (mobile only) ──────────────
  function syncStickyBarHeight() {
    if (window.innerWidth <= 768 && stickyBar) {
      document.documentElement.style.setProperty(
        '--mobile-cta-height',
        stickyBar.offsetHeight + 'px'
      );
    } else {
      document.documentElement.style.removeProperty('--mobile-cta-height');
    }
  }
  syncStickyBarHeight();
  window.addEventListener('resize', syncStickyBarHeight);


  // ── FAQ ACCORDION ──────────────────────────────────────────
  const firstFaq = document.querySelector('.faq-item--open');
  if (firstFaq) {
    const firstAnswer = firstFaq.querySelector('.faq-item__answer');
    if (firstAnswer) firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
  }

  document.querySelectorAll('.faq-item').forEach(item => {
    const btn    = item.querySelector('.faq-item__question');
    const answer = item.querySelector('.faq-item__answer');

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.faq-item').forEach(i => {
        i.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        i.querySelector('.faq-item__answer').style.maxHeight = '0';
      });

      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });


  // ── SINGLE PACK OFFER + BIOTINE UPSELL ──────────────────────
  // One offer only (Le Pack Complet, 359). The biotine upsell is an optional
  // add-on toggled in the order modal; it adjusts the total live and, when
  // checked, is sent to the Worker as a second line item.
  const PACK = SLV_VARIANTS[0] || { id: null, price: 0, priceFormatted: '' };

  // Biotine config from #selverine-cod-config.
  let BIOTINE = { variantId: null, price: 0, priceFormatted: '', compareAtFormatted: '' };
  try {
    const cfg = JSON.parse(document.getElementById('selverine-cod-config').textContent);
    if (cfg.biotine) BIOTINE = cfg.biotine;
  } catch (e) {}

  const fmtDh = (cents) => {
    // Prices come from Shopify in cents (MAD). Format without trailing zeros.
    const n = Math.round(cents / 100);
    return n.toLocaleString('fr-FR') + ' dh';
  };

  // Biotine is no longer an in-form add-on — it is offered after the order is
  // placed, on the thank-you screen, as a link to its own product page. The
  // COD order created here is always the pack alone.
  const addBiotine = false;
  let selectedBundle = { bundle: 2, price: PACK.price, variantId: PACK.id };

  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyNote  = document.querySelector('[data-sticky-note]');

  function currentTotalCents() {
    return PACK.price + (addBiotine ? (BIOTINE.price || 0) : 0);
  }

  function recomputeTotals() {
    const totalFmt = fmtDh(currentTotalCents());

    if (stickyPrice)  stickyPrice.textContent = PACK.priceFormatted;
    if (stickyNote)   stickyNote.textContent  = '3 produits';
    const stickyCtaText = document.querySelector('.sticky-bar__cta-text');
    if (stickyCtaText) stickyCtaText.textContent = `Je commence ma routine — ${PACK.priceFormatted} →`;

    const omSubmit = document.querySelector('[data-om-submit]');
    if (omSubmit) omSubmit.textContent = `Je veux retrouver mes cheveux — ${totalFmt} →`;
  }

  recomputeTotals();


  // ── INLINE ORDER FORM ──────────────────────────────────────
  // The form now lives in the page. Every CTA scrolls to it and focuses the
  // first field, instead of opening a modal. InitiateCheckout fires once, the
  // first time the form is reached, so the pixel keeps its meaning.
  const orderInline = document.querySelector('[data-order-inline]');
  let checkoutPixelSent = false;

  function goToOrderForm() {
    if (!orderInline) return;
    orderInline.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (!checkoutPixelSent) {
      SLVPixel.initiateCheckout(selectedBundle.price, CURRENCY);
      checkoutPixelSent = true;
    }
    const firstInput = orderInline.querySelector('input[name="name"]');
    if (firstInput) {
      // Wait for the smooth scroll to settle before focusing, otherwise mobile
      // browsers jump the viewport and fight the scroll animation.
      setTimeout(() => firstInput.focus({ preventScroll: true }), 550);
    }
  }

  document.querySelectorAll('[data-order]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      goToOrderForm();
    });
  });

  // ── COD ORDER — collect name + phone, POST them to the Cloudflare Worker
  //    which creates a real Shopify order via the Admin API (COD / unpaid,
  //    inventory decremented). No Shopify cart, no Shopify checkout. On success
  //    we show the branded thank-you overlay with the real order number.
  const omForm      = document.querySelector('[data-om-form]');
  const omFormError = document.querySelector('[data-om-form-error]');
  const omSubmitBtn = document.querySelector('[data-om-submit]');

  // Worker endpoint comes from the section setting (#selverine-cod-config).
  const codConfigEl = document.getElementById('selverine-cod-config');
  let COD_WORKER_URL = '';
  try { COD_WORKER_URL = (JSON.parse(codConfigEl.textContent).workerUrl || '').trim(); } catch (e) {}

  function readField(name) {
    const el = omForm ? omForm.querySelector(`[name="${name}"]`) : null;
    return { el, value: el ? el.value.trim() : '' };
  }
  function setFieldError(name, message) {
    const { el } = readField(name);
    const errEl = omForm ? omForm.querySelector(`[data-err-for="${name}"]`) : null;
    if (el) el.classList.toggle('is-invalid', Boolean(message));
    if (errEl) errEl.textContent = message || '';
  }
  function validateForm() {
    const name  = readField('name').value;
    const phone = readField('phone').value;
    setFieldError('name', name.length >= 2 ? '' : 'Entrez votre nom complet');
    // Digits only for the phone check — accept spaces / dashes in the input.
    const phoneDigits = phone.replace(/\D/g, '');
    setFieldError('phone', phoneDigits.length >= 8 ? '' : 'Numéro de téléphone invalide');
    const ok = name.length >= 2 && phoneDigits.length >= 8;
    return ok ? { name, phone } : null;
  }

  // Live-clear errors as the user types.
  if (omForm) {
    omForm.querySelectorAll('input').forEach((input) => {
      input.addEventListener('input', () => setFieldError(input.name, ''));
    });
  }

  // Reveal the branded thank-you overlay with the real order details.
  function showThankYou(cust, orderName) {
    const overlay = document.querySelector('[data-thankyou]');

    const setText = (sel, val) => {
      const el = overlay ? overlay.querySelector(sel) : null;
      if (el && val != null) el.textContent = val;
    };
    const bundleLabel = 'Le Pack Complet · 3 produits' + (addBiotine ? ' + Biotine' : '');
    setText('[data-ty-name]', cust.name.split(' ')[0] || cust.name);
    setText('[data-ty-ref]', orderName || '—');
    setText('[data-ty-bundle]', bundleLabel);
    setText('[data-ty-total]', fmtDh(currentTotalCents()));

    if (overlay) {
      overlay.hidden = false;
      void overlay.offsetWidth; // force reflow so animations run
      overlay.classList.add('is-visible');
      document.body.classList.add('modal-open');
      // The thank-you overlay is now the final screen — no redirect.
      const redirectNote = overlay.querySelector('.slvty-redirect');
      if (redirectNote) redirectNote.style.display = 'none';
    }
  }

  if (omSubmitBtn) {
    omSubmitBtn.addEventListener('click', async () => {
      if (omFormError) { omFormError.hidden = true; omFormError.textContent = ''; }

      const cust = validateForm();
      if (!cust) {
        const firstInvalid = omForm.querySelector('.is-invalid');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      if (!COD_WORKER_URL) {
        if (omFormError) {
          omFormError.hidden = false;
          omFormError.textContent = 'Configuration manquante. Veuillez réessayer plus tard.';
        }
        return;
      }

      const originalText = omSubmitBtn.textContent;
      omSubmitBtn.textContent = 'Traitement…';
      omSubmitBtn.disabled = true;

      // Fire the InitiateCheckout pixel (full basket incl. upsell).
      SLVPixel.initiateCheckout(currentTotalCents(), CURRENCY);

      try {
        const res = await fetch(COD_WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: cust.name,
            phone: cust.phone,
            variantId: selectedBundle.variantId,
            quantity: 1,
            price: selectedBundle.price,
            // Biotine upsell — Worker adds it as a 2nd line item when present.
            ...(addBiotine && BIOTINE.variantId
              ? { addonVariantId: BIOTINE.variantId, addonQuantity: 1 }
              : {}),
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) {
          throw new Error(data.error || 'order failed');
        }

        // Fire the Purchase pixel for the real order, then show thank-you.
        SLVPixel.track('Purchase', {
          content_ids: addBiotine ? ['selverine', 'biotine'] : ['selverine'],
          content_type: 'product',
          currency: data.currency || CURRENCY,
          value: Number(data.total) || (currentTotalCents() / 100),
        });

        showThankYou(cust, data.order_name);
      } catch (err) {
        omSubmitBtn.textContent = originalText;
        omSubmitBtn.disabled = false;
        if (omFormError) {
          omFormError.hidden = false;
          omFormError.textContent = 'Une erreur est survenue. Veuillez réessayer.';
        }
      }
    });
  }


  // ── TEXTURE BARS ───────────────────────────────────────────
  const textureSection = document.querySelector('.texture');
  const fills          = document.querySelectorAll('.texture-prop__fill');

  if (textureSection && fills.length) {
    new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          fills.forEach((fill, i) => setTimeout(() => fill.classList.add('animated'), i * 150));
        }
      });
    }, { threshold: 0.3 }).observe(textureSection);
  }


  // ── SMOOTH SCROLL (in-page anchors only) ───────────────────
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      if (link.hasAttribute('data-order')) return;
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });


  // ── NAV — shadow on scroll + hamburger ─────────────────────
  const nav = document.querySelector('.nav');
  window.addEventListener('scroll', () => {
    if (!nav) return;
    nav.style.boxShadow = window.scrollY > 60 ? '0 2px 20px rgba(0,0,0,0.06)' : '';
  }, { passive: true });

  const hamburger = document.querySelector('.nav__hamburger');
  const navLinks  = document.querySelector('.nav__links');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('is-open');
      hamburger.classList.toggle('is-active', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen);
    });
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) {
        navLinks.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }


  // ── PARALLAX HERO (desktop only — skip on touch devices) ───
  const heroImg = document.querySelector('.hero__image');
  const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (heroImg && !isTouchDevice) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < window.innerHeight) {
        heroImg.style.transform = `translateY(${y * 0.12}px)`;
      }
    }, { passive: true });
  }


  // ── ORBIT FLOAT (desktop only) ─────────────────────────────
  if (!isTouchDevice) {
    document.querySelectorAll('.orbit-item').forEach((item, i) => {
      const amp   = 5 + i * 2;
      const speed = 2800 + i * 600;
      const phase = i * (Math.PI / 2);
      let start   = null;

      const animate = (ts) => {
        if (!start) start = ts;
        const y = Math.sin(((ts - start) / speed) * Math.PI * 2 + phase) * amp;
        item.style.transform = `translateY(${y}px)`;
        requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    });
  }


  // ── TESTIMONIAL SLIDER ─────────────────────────────────────
  const testiTrack = document.querySelector('[data-testi-track]');
  const testiDots  = document.querySelector('[data-testi-dots]');
  if (testiTrack && testiDots) {
    const slides = testiTrack.querySelectorAll('.testi-slide');
    let current = 0;
    let timer;

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'testi-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Avis ${i + 1}`);
      dot.addEventListener('click', () => goTo(i));
      testiDots.appendChild(dot);
    });

    function goTo(idx) {
      current = (idx + slides.length) % slides.length;
      testiTrack.style.transform = `translateX(-${current * 100}%)`;
      testiDots.querySelectorAll('.testi-dot').forEach((d, i) =>
        d.classList.toggle('active', i === current));
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), 7500);
    }

    timer = setInterval(() => goTo(current + 1), 7500);

    let startX = 0;
    testiTrack.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    testiTrack.addEventListener('touchend',   e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
    });
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selverine-landing"] && !Shopify.designMode) return;
  try {
    
/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   SELVERINE â€” Landing section scripts (Shopify port)
â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */

const SLVPixel = (function () {
  function cookie(name) {
    const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function param(name) {
    return new URLSearchParams(location.search).get(name) || '';
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  const fbclid = param('fbclid');
  if (fbclid && !cookie('_fbc')) {
    try { localStorage.setItem('slv_fbclid', fbclid); } catch (e) {}
  }
  function getFbclid() {
    return fbclid || (function () { try { return localStorage.getItem('slv_fbclid') || ''; } catch (e) { return ''; } })();
  }
  function getFbc() {
    const c = cookie('_fbc');
    if (c) return c;
    const id = getFbclid();
    return id ? `fb.1.${Date.now()}.${id}` : '';
  }
  function ready() { return typeof window.fbq === 'function' || !!window.ttq; }

  return {
    available: ready,
    data() {
      return { fbp: cookie('_fbp'), fbc: getFbc(), fbclid: getFbclid() };
    },
    newEventId: uuid,
    track(event, custom, eventId) {
      // Fans out to Meta + TikTok with a shared event id.
      try {
        if (window.SLVTrack) return window.SLVTrack.track(event, custom || {}, eventId);
        if (typeof window.fbq === 'function') {
          window.fbq('track', event, custom || {}, eventId ? { eventID: eventId } : undefined);
        }
      } catch (e) { /* never break UX for analytics */ }
    },
    viewContent(productName, currency) {
      this.track('ViewContent', {
        content_name: productName || 'SELVERINE',
        content_ids: ['selverine'],
        content_type: 'product',
        currency: currency || 'MAD',
      });
    },
    initiateCheckout(value, currency) {
      this.track('InitiateCheckout', {
        content_ids: ['selverine'],
        content_type: 'product',
        currency: currency || 'MAD',
        value: Number(value) || 0,
      });
    },
  };
})();

document.addEventListener('DOMContentLoaded', () => {

  const root = document.querySelector('[data-whatsapp-number]')?.closest('[id^="shopify-section-"]') || document;

  const variantDataEl = document.getElementById('selverine-variants-data');
  const SLV_VARIANTS = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  const CURRENCY = 'MAD';

  SLVPixel.viewContent('SELVERINE', CURRENCY);

  // â”€â”€ SCROLL ANIMATIONS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = parseInt(el.dataset.delay) || 0;
        setTimeout(() => el.classList.add('in-view'), delay);
        revealObserver.unobserve(el);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.fade-up, .fade-in')
    .forEach(el => revealObserver.observe(el));


  // â”€â”€ STICKY BAR â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const stickyBar = document.querySelector('[data-sticky-bar]');
  const hero      = document.querySelector('.hero');

  if (hero && stickyBar) {
    new IntersectionObserver((entries) => {
      entries.forEach(e => {
        const visible = !e.isIntersecting;
        stickyBar.classList.toggle('is-visible', visible);
        if (whatsappWidget) whatsappWidget.classList.toggle('is-above-cta', visible);
      });
    }, { threshold: 0 }).observe(hero);
  }

  // â”€â”€ WHATSAPP FLOATING WIDGET â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const whatsappNumber = document.querySelector('[data-whatsapp-number]')?.dataset.whatsappNumber || '212780953565';
  const isArabicPage = document.documentElement.lang === 'ar';
  const whatsappMessage = isArabicPage
    ? 'Ù…Ø±Ø­Ø¨Ø§ ðŸ‘‹ØŒ Ø¹Ù†Ø¯ÙŠ Ø³Ø¤Ø§Ù„ Ø¹Ù„Ù‰ SELVERINE'
    : 'Bonjour ðŸ‘‹, j\'ai une question sur SELVERINE';
  const waHref = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  const bubbleHTML = isArabicPage
    ? 'ðŸ‘‹ Ø¹Ù†Ø¯Ùƒ Ø³Ø¤Ø§Ù„ØŸ <strong>Ø±Ø§Ø³Ù„Ù†Ø§ Ø¹Ù„Ù‰ ÙˆØ§ØªØ³Ø§Ø¨</strong>ØŒ ÙƒÙ†Ø¬Ø§ÙˆØ¨Ùˆ Ø¨Ø³Ø±Ø¹Ø© ðŸ’¬'
    : 'ðŸ‘‹ Une question ? <strong>Ã‰crivez-nous sur WhatsApp</strong> â€” rÃ©ponse en quelques minutes ðŸ’¬';
  const closeLabel = isArabicPage ? 'Ø¥ØºÙ„Ø§Ù‚' : 'Fermer';
  const waSvg = '<svg viewBox="0 0 32 32" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M16.004 2.667c-7.36 0-13.333 5.973-13.333 13.333 0 2.351.615 4.646 1.783 6.667L2.667 29.333l6.83-1.76a13.27 13.27 0 0 0 6.507 1.694h.006c7.36 0 13.333-5.973 13.333-13.333S23.364 2.667 16.004 2.667zm0 24.4h-.005a11.06 11.06 0 0 1-5.636-1.543l-.404-.24-4.052 1.044 1.08-3.948-.264-.406a11.04 11.04 0 0 1-1.69-5.907c0-6.106 4.968-11.073 11.076-11.073 2.958 0 5.738 1.153 7.83 3.246a10.996 10.996 0 0 1 3.242 7.834c-.003 6.106-4.971 11.073-11.077 11.073zm6.077-8.294c-.333-.167-1.966-.97-2.271-1.081-.305-.111-.527-.167-.749.167-.222.333-.86 1.08-1.055 1.303-.194.222-.388.25-.72.083-.333-.167-1.406-.518-2.678-1.652-.99-.883-1.658-1.974-1.852-2.307-.194-.333-.02-.513.146-.679.15-.149.333-.389.5-.583.167-.194.222-.333.333-.556.111-.222.056-.417-.028-.583-.083-.167-.749-1.807-1.026-2.474-.27-.65-.545-.562-.749-.573l-.638-.011c-.222 0-.583.083-.888.417-.305.333-1.164 1.138-1.164 2.776 0 1.638 1.192 3.221 1.358 3.443.167.222 2.347 3.583 5.687 5.024.795.343 1.415.548 1.898.702.797.253 1.523.217 2.096.132.639-.095 1.966-.804 2.243-1.581.278-.777.278-1.443.194-1.581-.083-.139-.305-.222-.638-.389z"/></svg>';

  const whatsappWidget = document.createElement('div');
  whatsappWidget.className = 'whatsapp-widget';
  whatsappWidget.innerHTML =
    '<a class="whatsapp-bubble" href="' + waHref + '" target="_blank" rel="noopener noreferrer">' +
      '<span class="whatsapp-bubble__text">' + bubbleHTML + '</span>' +
    '</a>' +
    '<button class="whatsapp-bubble__close" type="button" aria-label="' + closeLabel + '">&times;</button>' +
    '<a class="whatsapp-fab" href="' + waHref + '" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">' + waSvg + '</a>';
  document.body.appendChild(whatsappWidget);

  let bubbleClosed = false;
  try { bubbleClosed = sessionStorage.getItem('waBubbleClosed') === '1'; } catch (e) {}
  if (!bubbleClosed) {
    setTimeout(() => whatsappWidget.classList.add('bubble-open'), 2000);
  }
  const whatsappClose = whatsappWidget.querySelector('.whatsapp-bubble__close');
  whatsappClose.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    whatsappWidget.classList.remove('bubble-open');
    try { sessionStorage.setItem('waBubbleClosed', '1'); } catch (err) {}
  });

  // â”€â”€ STICKY BAR HEIGHT â†’ CSS VAR (mobile only) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function syncStickyBarHeight() {
    if (window.innerWidth <= 768 && stickyBar) {
      document.documentElement.style.setProperty(
        '--mobile-cta-height',
        stickyBar.offsetHeight + 'px'
      );
    } else {
      document.documentElement.style.removeProperty('--mobile-cta-height');
    }
  }
  syncStickyBarHeight();
  window.addEventListener('resize', syncStickyBarHeight);


  // â”€â”€ FAQ ACCORDION â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const firstFaq = document.querySelector('.faq-item--open');
  if (firstFaq) {
    const firstAnswer = firstFaq.querySelector('.faq-item__answer');
    if (firstAnswer) firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
  }

  document.querySelectorAll('.faq-item').forEach(item => {
    const btn    = item.querySelector('.faq-item__question');
    const answer = item.querySelector('.faq-item__answer');

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.faq-item').forEach(i => {
        i.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        i.querySelector('.faq-item__answer').style.maxHeight = '0';
      });

      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });


  // â”€â”€ SINGLE PACK OFFER + BIOTINE UPSELL â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // One offer only (Ø§Ù„Ù…Ø¬Ù…ÙˆØ¹Ø© Ø§Ù„ÙƒØ§Ù…Ù„Ø©, 359). The biotine upsell is an optional
  // add-on toggled in the order modal; it adjusts the total live and, when
  // checked, is sent to the Worker as a second line item.
  const PACK = SLV_VARIANTS[0] || { id: null, price: 0, priceFormatted: '' };

  // Biotine config from #selverine-cod-config.
  let BIOTINE = { variantId: null, price: 0, priceFormatted: '', compareAtFormatted: '' };
  try {
    const cfg = JSON.parse(document.getElementById('selverine-cod-config').textContent);
    if (cfg.biotine) BIOTINE = cfg.biotine;
  } catch (e) {}

  const fmtDh = (cents) => {
    // Prices come from Shopify in cents (MAD). Format without trailing zeros.
    const n = Math.round(cents / 100);
    return n.toLocaleString('fr-FR') + ' dh';
  };

  // Biotine is no longer an in-form add-on â€” it is offered after the order is
  // placed, on the thank-you screen, as a link to its own product page. The
  // COD order created here is always the pack alone.
  const addBiotine = false;
  let selectedBundle = { bundle: 2, price: PACK.price, variantId: PACK.id };

  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyNote  = document.querySelector('[data-sticky-note]');

  function currentTotalCents() {
    return PACK.price + (addBiotine ? (BIOTINE.price || 0) : 0);
  }

  function recomputeTotals() {
    const totalFmt = fmtDh(currentTotalCents());

    if (stickyPrice)  stickyPrice.textContent = PACK.priceFormatted;
    if (stickyNote)   stickyNote.textContent  = '3 Ù…Ù†ØªØ¬Ø§Øª';
    const stickyCtaText = document.querySelector('.sticky-bar__cta-text');
    if (stickyCtaText) stickyCtaText.textContent = `Ø£Ø¨Ø¯Ø£ Ø±ÙˆØªÙŠÙ†ÙŠ â€” ${PACK.priceFormatted} â†’`;

    const omSubmit = document.querySelector('[data-om-submit]');
    if (omSubmit) omSubmit.textContent = `Ù†Ø¹Ù…ØŒ Ø£Ø±ÙŠØ¯ Ø¥ÙŠÙ‚Ø§Ù Ø§Ù„ØªØ³Ø§Ù‚Ø· â€” ${totalFmt} â†’`;
  }

  recomputeTotals();


  // â”€â”€ INLINE ORDER FORM â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // The form now lives in the page. Every CTA scrolls to it and focuses the
  // first field, instead of opening a modal. InitiateCheckout fires once, the
  // first time the form is reached, so the pixel keeps its meaning.
  const orderInline = document.querySelector('[data-order-inline]');
  let checkoutPixelSent = false;

  function goToOrderForm() {
    if (!orderInline) return;
    orderInline.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (!checkoutPixelSent) {
      SLVPixel.initiateCheckout(selectedBundle.price, CURRENCY);
      checkoutPixelSent = true;
    }
    const firstInput = orderInline.querySelector('input[name="name"]');
    if (firstInput) {
      // Wait for the smooth scroll to settle before focusing, otherwise mobile
      // browsers jump the viewport and fight the scroll animation.
      setTimeout(() => firstInput.focus({ preventScroll: true }), 550);
    }
  }

  document.querySelectorAll('[data-order]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      goToOrderForm();
    });
  });

  // â”€â”€ COD ORDER â€” collect name + phone, POST them to the Cloudflare Worker
  //    which creates a real Shopify order via the Admin API (COD / unpaid,
  //    inventory decremented). No Shopify cart, no Shopify checkout. On success
  //    we show the branded thank-you overlay with the real order number.
  const omForm      = document.querySelector('[data-om-form]');
  const omFormError = document.querySelector('[data-om-form-error]');
  const omSubmitBtn = document.querySelector('[data-om-submit]');

  // Worker endpoint comes from the section setting (#selverine-cod-config).
  const codConfigEl = document.getElementById('selverine-cod-config');
  let COD_WORKER_URL = '';
  try { COD_WORKER_URL = (JSON.parse(codConfigEl.textContent).workerUrl || '').trim(); } catch (e) {}

  function readField(name) {
    const el = omForm ? omForm.querySelector(`[name="${name}"]`) : null;
    return { el, value: el ? el.value.trim() : '' };
  }
  function setFieldError(name, message) {
    const { el } = readField(name);
    const errEl = omForm ? omForm.querySelector(`[data-err-for="${name}"]`) : null;
    if (el) el.classList.toggle('is-invalid', Boolean(message));
    if (errEl) errEl.textContent = message || '';
  }
  function validateForm() {
    const name  = readField('name').value;
    const phone = readField('phone').value;
    setFieldError('name', name.length >= 2 ? '' : 'Ø¯Ø®Ù‘Ù„ Ø§Ù„Ø§Ø³Ù… Ø§Ù„ÙƒØ§Ù…Ù„');
    // Digits only for the phone check â€” accept spaces / dashes in the input.
    const phoneDigits = phone.replace(/\D/g, '');
    setFieldError('phone', phoneDigits.length >= 8 ? '' : 'Ø±Ù‚Ù… Ø§Ù„Ù‡Ø§ØªÙ Ù…Ø§Ø´ÙŠ ØµØ­ÙŠØ­');
    const ok = name.length >= 2 && phoneDigits.length >= 8;
    return ok ? { name, phone } : null;
  }

  // Live-clear errors as the user types.
  if (omForm) {
    omForm.querySelectorAll('input').forEach((input) => {
      input.addEventListener('input', () => setFieldError(input.name, ''));
    });
  }

  // Reveal the branded thank-you overlay with the real order details.
  function showThankYou(cust, orderName) {
    const overlay = document.querySelector('[data-thankyou]');

    const setText = (sel, val) => {
      const el = overlay ? overlay.querySelector(sel) : null;
      if (el && val != null) el.textContent = val;
    };
    const bundleLabel = 'Ø§Ù„Ù…Ø¬Ù…ÙˆØ¹Ø© Ø§Ù„ÙƒØ§Ù…Ù„Ø© Â· 3 Ù…Ù†ØªØ¬Ø§Øª' + (addBiotine ? ' + Ø¨ÙŠÙˆØªÙŠÙ†' : '');
    setText('[data-ty-name]', cust.name.split(' ')[0] || cust.name);
    setText('[data-ty-ref]', orderName || 'â€”');
    setText('[data-ty-bundle]', bundleLabel);
    setText('[data-ty-total]', fmtDh(currentTotalCents()));

    if (overlay) {
      overlay.hidden = false;
      void overlay.offsetWidth; // force reflow so animations run
      overlay.classList.add('is-visible');
      document.body.classList.add('modal-open');
      // The thank-you overlay is now the final screen â€” no redirect.
      const redirectNote = overlay.querySelector('.slvty-redirect');
      if (redirectNote) redirectNote.style.display = 'none';
    }
  }

  if (omSubmitBtn) {
    omSubmitBtn.addEventListener('click', async () => {
      if (omFormError) { omFormError.hidden = true; omFormError.textContent = ''; }

      const cust = validateForm();
      if (!cust) {
        const firstInvalid = omForm.querySelector('.is-invalid');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      if (!COD_WORKER_URL) {
        if (omFormError) {
          omFormError.hidden = false;
          omFormError.textContent = 'Ø­Ø¯Ø« Ø®Ù„Ù„ ØªÙ‚Ù†ÙŠ. ÙŠÙØ±Ø¬Ù‰ Ø§Ù„Ù…Ø­Ø§ÙˆÙ„Ø© Ù„Ø§Ø­Ù‚Ù‹Ø§.';
        }
        return;
      }

      const originalText = omSubmitBtn.textContent;
      omSubmitBtn.textContent = 'Ø¬Ø§Ø±Ù Ø§Ù„Ù…Ø¹Ø§Ù„Ø¬Ø©â€¦';
      omSubmitBtn.disabled = true;

      // Fire the InitiateCheckout pixel (full basket incl. upsell).
      SLVPixel.initiateCheckout(currentTotalCents(), CURRENCY);

      try {
        const res = await fetch(COD_WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: cust.name,
            phone: cust.phone,
            variantId: selectedBundle.variantId,
            quantity: 1,
            price: selectedBundle.price,
            // Biotine upsell â€” Worker adds it as a 2nd line item when present.
            ...(addBiotine && BIOTINE.variantId
              ? { addonVariantId: BIOTINE.variantId, addonQuantity: 1 }
              : {}),
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) {
          throw new Error(data.error || 'order failed');
        }

        // Fire the Purchase pixel for the real order, then show thank-you.
        SLVPixel.track('Purchase', {
          content_ids: addBiotine ? ['selverine', 'biotine'] : ['selverine'],
          content_type: 'product',
          currency: data.currency || CURRENCY,
          value: Number(data.total) || (currentTotalCents() / 100),
        });

        showThankYou(cust, data.order_name);
      } catch (err) {
        omSubmitBtn.textContent = originalText;
        omSubmitBtn.disabled = false;
        if (omFormError) {
          omFormError.hidden = false;
          omFormError.textContent = 'Ø­Ø¯Ø« Ø®Ø·Ø£. ÙŠÙØ±Ø¬Ù‰ Ø§Ù„Ù…Ø­Ø§ÙˆÙ„Ø© Ù…Ø±Ø© Ø£Ø®Ø±Ù‰.';
        }
      }
    });
  }


  // â”€â”€ TEXTURE BARS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const textureSection = document.querySelector('.texture');
  const fills          = document.querySelectorAll('.texture-prop__fill');

  if (textureSection && fills.length) {
    new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          fills.forEach((fill, i) => setTimeout(() => fill.classList.add('animated'), i * 150));
        }
      });
    }, { threshold: 0.3 }).observe(textureSection);
  }


  // â”€â”€ SMOOTH SCROLL (in-page anchors only) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      if (link.hasAttribute('data-order')) return;
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });


  // â”€â”€ NAV â€” shadow on scroll + hamburger â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const nav = document.querySelector('.nav');
  window.addEventListener('scroll', () => {
    if (!nav) return;
    nav.style.boxShadow = window.scrollY > 60 ? '0 2px 20px rgba(0,0,0,0.06)' : '';
  }, { passive: true });

  const hamburger = document.querySelector('.nav__hamburger');
  const navLinks  = document.querySelector('.nav__links');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('is-open');
      hamburger.classList.toggle('is-active', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen);
    });
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) {
        navLinks.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }


  // â”€â”€ PARALLAX HERO (desktop only â€” skip on touch devices) â”€â”€â”€
  const heroImg = document.querySelector('.hero__image');
  const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (heroImg && !isTouchDevice) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < window.innerHeight) {
        heroImg.style.transform = `translateY(${y * 0.12}px)`;
      }
    }, { passive: true });
  }


  // â”€â”€ ORBIT FLOAT (desktop only) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  if (!isTouchDevice) {
    document.querySelectorAll('.orbit-item').forEach((item, i) => {
      const amp   = 5 + i * 2;
      const speed = 2800 + i * 600;
      const phase = i * (Math.PI / 2);
      let start   = null;

      const animate = (ts) => {
        if (!start) start = ts;
        const y = Math.sin(((ts - start) / speed) * Math.PI * 2 + phase) * amp;
        item.style.transform = `translateY(${y}px)`;
        requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    });
  }


  // â”€â”€ TESTIMONIAL SLIDER â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const testiTrack = document.querySelector('[data-testi-track]');
  const testiDots  = document.querySelector('[data-testi-dots]');
  if (testiTrack && testiDots) {
    const slides = testiTrack.querySelectorAll('.testi-slide');
    let current = 0;
    let timer;

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'testi-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Avis ${i + 1}`);
      dot.addEventListener('click', () => goTo(i));
      testiDots.appendChild(dot);
    });

    function goTo(idx) {
      current = (idx + slides.length) % slides.length;
      testiTrack.style.transform = `translateX(-${current * 100}%)`;
      testiDots.querySelectorAll('.testi-dot').forEach((d, i) =>
        d.classList.toggle('active', i === current));
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), 7500);
    }

    timer = setInterval(() => goTo(current + 1), 7500);

    let startX = 0;
    testiTrack.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    testiTrack.addEventListener('touchend',   e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
    });
  }

});


  } catch(e) { console.error(e); }
})();
})();
